const { createSlice } = require('@reduxjs/toolkit');
const initialState = {
  customerInfo: {},
  customerInfo2: {},
  serviceDetailsRetrieveResponse: {},
  serviceDetailsRetrieveResponseCopy: {},
  lastLoginDate: {},
  lastLoginDateDetails: { userLastLoginDate: '' },
  postpaidAccount: {},
  postpaidAccountAddress: {},
  serviceTypes: {},
  suppStatus: false,
  custMngInternet: {},
  mobileNumber: {},
  serviceDetailsRESData: {},
  openOrderRESData: {},
  queryMutipleBALRESData: {},
  queryBalSumENVData: {},
  fetchorgRESData: {},
};
const CustomerSlicer = createSlice({
  name: 'GetCustomer',
  initialState,
  reducers: {
    getCustomerInfo: (state, action) => {
      state.customerInfo = action.payload;
    },
    getCustomerInfo2: (state, action) => {
      state.customerInfo2 = action.payload;
    },
    getMobileNumber: (state, action) => {
      state.mobileNumber = action.payload;
    },
    // serviceDetailsRetrieveResponse
    getAPI2: (state, action) => {
      state.serviceDetailsRetrieveResponse = action.payload;
    },
    getAPI2Copy: (state, action) => {
      state.serviceDetailsRetrieveResponseCopy = action.payload;
    },
    getLastLoginDate: (state, action) => {
      state.lastLoginDate = action.payload;
    },
    setLastLoginDate: (state, action) => {
      state.lastLoginDateDetails = action.payload;
    },
    getpostPaidAccountStatus: (state, action) => {
      state.postpaidAccount = action.payload;
    },
    getpostPaidAccountAddress: (state, action) => {
      state.postpaidAccountAddress = action.payload;
    },
    getServiceTypes: (state, action) => {
      state.serviceTypes = action.payload;
    },
    getSupplementaryStatus: (state, action) => {
      state.suppStatus = action.payload;
    },
    getCustManageInternet: (state, action) => {
      state.custMngInternet = action.payload;
    },
    getServiceRetDetailData: (state, action) => {
      state.serviceDetailsRESData = action.payload;
    },
    getOpenOrderData: (state, action) => {
      state.openOrderRESData = action.payload;
    },
    getQueryMultiData: (state, action) => {
      state.queryMutipleBALRESData = action.payload;
    },
    getQueryBalSumENV: (state, action) => {
      state.queryBalSumENVData = action.payload;
    },
    getFetchOrgDAta: (state, action) => {
      state.fetchorgRESData = action.payload;
    },
    resetCustomerState: () => initialState,
  },
});
export const {
  getCustomerInfo,
  getCustomerInfo2,
  getMobileNumber,
  getAPI2,
  getAPI2Copy,
  getLastLoginDate,
  setLastLoginDate,
  getpostPaidAccountStatus,
  getpostPaidAccountAddress,
  getServiceTypes,
  getSupplementaryStatus,
  getCustManageInternet,
  resetCustomerState,
  getServiceRetDetailData,
  getOpenOrderData,
  getQueryMultiData,
  getQueryBalSumENV,
  getFetchOrgDAta,
} = CustomerSlicer.actions;
export default CustomerSlicer.reducer;
